import { FieldConfiguration, TabConfiguration } from '@/types';

export const generateDefaultFieldOrder = (): string[] => {
  const fields: string[] = [
    'Booking Type',
    'Status',
    'Colour',
    'Project',
    'Cost Centre',
    'Customer',
    'Location',
    'Booking Reference',
    'Description',
    'Details',
    'From',
    'To',
  ];

  // Add User Char fields
  for (let i = 1; i <= 20; i++) {
    fields.push(`User Char ${i}`);
  }

  // Add User Number fields
  for (let i = 1; i <= 10; i++) {
    fields.push(`User Number ${i}`);
  }

  // Add User Flag fields
  for (let i = 1; i <= 10; i++) {
    fields.push(`User Flag ${i}`);
  }

  // Add User Date fields
  for (let i = 1; i <= 10; i++) {
    fields.push(`User Date ${i}`);
  }

  // Add User Notes fields
  for (let i = 1; i <= 5; i++) {
    fields.push(`User Notes ${i}`);
  }

  // Add User Time fields
  for (let i = 1; i <= 5; i++) {
    fields.push(`User Time ${i}`);
  }

  fields.push('Cost Centre Task');

  return fields;
};

export const generateDefaultFieldConfigurations = (): FieldConfiguration[] => {
  // All fields are unticked by default for new booking types
  // Users must explicitly opt-in to the fields they want to enable
  const fields: FieldConfiguration[] = [
    { fieldName: 'Booking Type', placeholder: 'Select booking type', defaultPlaceholder: 'Select booking type', isVisible: true, isRequired: false, isCompulsory: true, showTooltip: true, showOnCustomTab: false },
    { fieldName: 'Status', placeholder: 'Select status', defaultPlaceholder: 'Select status', isVisible: true, isRequired: false, isCompulsory: false, showTooltip: true, showOnCustomTab: false },
    { fieldName: 'Colour', placeholder: 'Select colour', defaultPlaceholder: 'Select colour', isVisible: false, isRequired: false, isCompulsory: false, showTooltip: false, showOnCustomTab: false },
    { fieldName: 'Booking Reference', placeholder: 'Enter booking reference', defaultPlaceholder: 'Enter booking reference', isVisible: false, isRequired: false, isCompulsory: false, showTooltip: false, showOnCustomTab: false },
    { fieldName: 'Project', placeholder: 'Select project', defaultPlaceholder: 'Select project', isVisible: false, isRequired: false, isCompulsory: false, showTooltip: false, showOnCustomTab: false },
    { fieldName: 'Cost Centre', placeholder: 'Select cost centre', defaultPlaceholder: 'Select cost centre', isVisible: false, isRequired: false, isCompulsory: false, showTooltip: false, showOnCustomTab: false },
    { fieldName: 'Customer', placeholder: 'Select customer', defaultPlaceholder: 'Select customer', isVisible: false, isRequired: false, isCompulsory: false, showTooltip: false, showOnCustomTab: false },
    { fieldName: 'Description', placeholder: 'Enter description', defaultPlaceholder: 'Enter description', isVisible: false, isRequired: false, isCompulsory: false, showTooltip: false, showOnCustomTab: false },
    { fieldName: 'Location', placeholder: 'Enter location', defaultPlaceholder: 'Enter location', isVisible: false, isRequired: false, isCompulsory: false, showTooltip: false, showOnCustomTab: false },
    { fieldName: 'Details', placeholder: 'Enter details', defaultPlaceholder: 'Enter details', isVisible: false, isRequired: false, isCompulsory: false, showTooltip: false, showOnCustomTab: false },
    { fieldName: 'From', placeholder: 'Select start date/time', defaultPlaceholder: 'Select start date/time', isVisible: true, isRequired: false, isCompulsory: true, showTooltip: true, showOnCustomTab: false },
    { fieldName: 'To', placeholder: 'Select end date/time', defaultPlaceholder: 'Select end date/time', isVisible: true, isRequired: false, isCompulsory: true, showTooltip: true, showOnCustomTab: false },
  ];

  // Add User Char 1-20
  for (let i = 1; i <= 20; i++) {
    fields.push({
      fieldName: `User Char ${i}`,
      placeholder: `Enter user char ${i}`,
      defaultPlaceholder: `Enter user char ${i}`,
      isVisible: false,
      isRequired: false,
      isCompulsory: false,
      showTooltip: false,
      showOnCustomTab: false,
    });
  }

  // Add User Number 1-10
  for (let i = 1; i <= 10; i++) {
    fields.push({
      fieldName: `User Number ${i}`,
      placeholder: `Enter user number ${i}`,
      defaultPlaceholder: `Enter user number ${i}`,
      isVisible: false,
      isRequired: false,
      isCompulsory: false,
      showTooltip: false,
      showOnCustomTab: false,
    });
  }

  // Add User Flag 1-10
  for (let i = 1; i <= 10; i++) {
    fields.push({
      fieldName: `User Flag ${i}`,
      placeholder: `Select user flag ${i}`,
      defaultPlaceholder: `Select user flag ${i}`,
      isVisible: false,
      isRequired: false,
      isCompulsory: false,
      showTooltip: false,
      showOnCustomTab: false,
    });
  }

  // Add User Date 1-10
  for (let i = 1; i <= 10; i++) {
    fields.push({
      fieldName: `User Date ${i}`,
      placeholder: `Select user date ${i}`,
      defaultPlaceholder: `Select user date ${i}`,
      isVisible: false,
      isRequired: false,
      isCompulsory: false,
      showTooltip: false,
      showOnCustomTab: false,
    });
  }

  // Add User Notes 1-5
  for (let i = 1; i <= 5; i++) {
    fields.push({
      fieldName: `User Notes ${i}`,
      placeholder: `Enter user notes ${i}`,
      defaultPlaceholder: `Enter user notes ${i}`,
      isVisible: false,
      isRequired: false,
      isCompulsory: false,
      showTooltip: false,
      showOnCustomTab: false,
    });
  }

  // Add User Time 1-5
  for (let i = 1; i <= 5; i++) {
    fields.push({
      fieldName: `User Time ${i}`,
      placeholder: `Select user time ${i}`,
      defaultPlaceholder: `Select user time ${i}`,
      isVisible: false,
      isRequired: false,
      isCompulsory: false,
      showTooltip: false,
      showOnCustomTab: false,
    });
  }

  // Add Cost Centre Task
  fields.push({
    fieldName: 'Cost Centre Task',
    placeholder: 'Select cost centre task',
    defaultPlaceholder: 'Select cost centre task',
    isVisible: false,
    isRequired: false,
    isCompulsory: false,
    showTooltip: false,
    showOnCustomTab: false,
  });

  return fields;
};

export const generateDefaultTabConfigurations = (): TabConfiguration[] => {
  return [
    { tabName: 'address', defaultName: 'Address & Contact', customName: '', isVisible: true },
    { tabName: 'history', defaultName: 'History', customName: '', isVisible: true },
    { tabName: 'project-notes', defaultName: 'Project Notes', customName: '', isVisible: true },
    { tabName: 'custom', defaultName: 'Custom', customName: '', isVisible: false },
  ];
};
